import styled from 'styled-components'
import { ResponsiveImage } from '../../ResponsiveImage/ResponsiveImage'

export const BlocksGrid = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 0.8rem;
  grid-template-areas:
    'LookbookBlockItem0 LookbookBlockItem1'
    'LookbookBlockItem2 LookbookBlockItem2'
    'LookbookBlockItem2 LookbookBlockItem2'
    'LookbookBlockItem3 LookbookBlockItem3'
    'LookbookBlockItem3 LookbookBlockItem3'
    'LookbookBlockItem4 LookbookBlockItem5';

  & > div {
    &:nth-child(1) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem0;
    }

    &:nth-child(2) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem1;
    }

    &:nth-child(3) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem2;
    }

    &:nth-child(4) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem3;
    }

    &:nth-child(5) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem4;
    }

    &:nth-child(6) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem5;
    }
  }

  @media screen and (min-width: 768px) {
    grid-auto-columns: 1fr;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-areas:
      'LookbookBlockItem0 LookbookBlockItem1 LookbookBlockItem2 LookbookBlockItem2'
      'LookbookBlockItem3 LookbookBlockItem3 LookbookBlockItem2 LookbookBlockItem2'
      'LookbookBlockItem3 LookbookBlockItem3 LookbookBlockItem4 LookbookBlockItem5';
  }
`

export const SquareImage = styled(ResponsiveImage)`
  object-fit: cover;
  height: 100%;
  aspect-ratio: 1;
`
